/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Wrap_LabelInputs */



/**
* | output |
* | --- |
* | "Wrap value" |
*
* @param {Transcript_Export_Wrap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_wrap_label = /** @type {((inputs?: Transcript_Export_Wrap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Wrap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wrap value")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wrap value")
	if (locale === "it") return /** @type {LocalizedString} */ ("Wrap value")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Wrap value")
	if (locale === "es") return /** @type {LocalizedString} */ ("Wrap value")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Wrap value")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Wrap value")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Wrap value")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Wrap value")
	return /** @type {LocalizedString} */ ("Wrap value")
});